import classes from "./Icon.module.css";
import {ReactNode, cloneElement, ReactElement} from "react";

type IconProps = {
    /**
     * Icon
     * @author Kacper Faber
     * @since 0.1.9
    */
    children: ReactNode;

    /**
     * On icon is clicked.
     * @author Kacper Faber
     * @since 0.1.9
    */
    onClick?: () => void;
};

/**
 * Menu 'item'
 * @author Kacper Faber
 * @since 0.1.9
*/
function Icon(props: IconProps) {
    return (
        <div className={classes.root} onClick={props.onClick}>
            { cloneElement(props.children as ReactElement, { size: 17 }) }
        </div>
    );
}

export default Icon;